/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import { getAllDefaultStates } from '@/store/utils/default-state-factory.js';

const mutations = {
	// ////////////////////////////////////////////
	// SIDEBAR & UI UX
	// ////////////////////////////////////////////
	updateSideBarWidth(state, width) {
		state.sidebarWidth = width;
	},
	updateSideBarItemsMin(state, val) {
		state.sidebarItemsMin = val;
	},
	toggleReduceButton(state, val) {
		state.reduceButton = val;
	},
	toggleIsSideBarActive(state, value) {
		state.isSidebarActive = value;
	},
	updateTheme(state, val) {
		state.theme = val;
	},
	updateWindowBreakpoint(state, val) {
		state.breakpoint = val;
	},
	updatePrimaryColor(state, val) {
		state.themePrimaryColor = val;
	},
	updateReduce(state, val) {
		state.reduce = val;
	},
	updateRouterIndex(state, val) {
		state.routerIndex++;
	},
	updateSystemReady(state, val) {
		state.isSystemReady = val;
		state.routerIndex++;
	},
	updateGuideRunning(state, val) {
		state.tourGuideRunning = val;
	},
	resetState(state, val) {
		state.invoice = {
			...state.invoice,
			Invoices: [],
			InvoicesTotal: 0
		};
		state.inbox = {
			...state.inbox,
			EmailList: [],
			EmailTotal: 0,
			TotalEmailUnRead: 0,
			TotalEmailUnReadV2: 0
		};
		state.resource = {
			...state.resource,
			Resources: [],
			Orders: []
		};
		state.licenseinfo = {
			...state.licenseinfo,
			LicenseInfo: {}
		};
		state.layout = {};
		state.stick = {
			Stick: []
		};
		state.connectInvoice = {
			...state.connectInvoice,
			DataConnectTaxaxion: null
		};
	},
	/**
	 * Created by NVHIEN on 25/08/2025
	 * Thực hiện reset cache trong indexDB về mặc định
	 * Reset state của các module về giá trị mặc định để đảm bảo tính nhất quán
	 * Những store nào cần reset thực hiện reset hết
	 * @param {Object} state - Vuex state object chứa tất cả các module state
	 * @param {*} val - Tham số truyền vào (hiện tại chưa sử dụng)
	 * @remarks
	 * Hàm này sử dụng factory functions từ utils/default-state-factory.js
	 * để đảm bảo tính nhất quán giữa initial state và reset state.
	 * Các module được reset: organization, subscriber, user
	 */
	resetStateDefault(state, val) {
		try {
			// Lấy tất cả state mặc định từ factory function
			const defaultStates = getAllDefaultStates();
			if (!defaultStates) return;

			// Reset từng module một cách có hệ thống
			const moduleKeys = Object.keys(defaultStates);
			if (!moduleKeys) return;

			// Duyệt qua từng module và gán lại state mặc định
			moduleKeys.forEach(moduleKey => {
				try {
					if (state[moduleKey]) {
						Object.assign(state[moduleKey], defaultStates[moduleKey]);
					}
				} catch (e) {
					console.error(e);
				}
			});
		} catch (ex) {
			console.error(ex);
		}
	},
	resetSupplierStateAfterOrganizationChange(state, val) {
		state.supplier = { ...state.supplier, SuppliersCombobox: [] };
	},
	updateStepTourGuideStarted(state, val) {
		state.GuideStartedStep = val;
	},
	updateStepTourGuideStartedV2(state, val) {
		state.GuideStartedStepV2 = val;
	},
	/**
	 * Hàm update state
	 * @param {*} state
	 * @param {*} val
	 * @author hvanh - 19.1.2024
	 */
	updateGridInfo(state, val) {
		state.GridInfo = { ...state.GridInfo, ...val };
	},
	resetStateConfig(state, val) {
		//Kiểm tra xem có phải phiên bản mới cần reset config hay không
		if (!state || !state.user || !state.user.user || state.user.user.Version == val) {
			return;
		}

		//Reset config
		state.licenseinfo = {
			...state.licenseinfo,
			Config: {}
		};
		state.layout = {
			...state.layout,
			LayoutInfos: []
		};
		state.columnexport = {
			...state.columnexport,
			ColumnExports: []
		};
		//Reset cache của module organization
		state.organization = {
			...state.organization,
			AllTreeOrganizations: [],
			AllOrganizations: [],
			FullTreeOrganizations: [],
			OrganizationInfos: []
		};
	},
	updateLoadingTotalAmountPage(state, res) {
		state.isLoadingTotalAmountPage = res;
	},
	updateTakeItem(state, res) {
		state.TakeItem = res;
	},
	updateLoadingPushData(state, res) {
		state.isLoadingPushData = res;
	},

	/**
	 * Created by NVHIEN on 09/05/2025
	 * Cập nhật trạng thái popup cập nhật CCCD đang hoạt động
	 */
	updateIdentificationPopupActive(state, value) {
		state.updateIdentificationPopupActive = value;
	}
};

export default mutations;
